var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "archive-collection"
  }, [_c('div', {
    staticClass: "archive-collection__item is-header"
  }, [_c('h3', {
    staticClass: "title is-3",
    domProps: {
      "innerHTML": _vm._s(_vm.titleText(_vm.collection))
    }
  })]), _vm._v(" "), _vm._l((_vm.groups), function(group, groupIndex) {
    return _c('a', {
      key: ("group-" + groupIndex),
      staticClass: "archive-collection__item",
      class: {
        'is-expanded': group.expanded
      },
      on: {
        "click": function($event) {
          _vm.showCollectionItem(group)
        }
      }
    }, [_c('ArchiveCollectionItem', {
      attrs: {
        "itemData": group.objects,
        "title": group.title,
        "caption": group.caption
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.ungroupedObjects), function(object, objIndex) {
    return _c('a', {
      key: ("ungrouped-obj-" + objIndex),
      staticClass: "archive-collection__item",
      on: {
        "click": function($event) {
          _vm.showCollectionItem(object)
        }
      }
    }, [_c('ArchiveCollectionItem', {
      attrs: {
        "itemData": object,
        "title": object.title,
        "caption": object.caption
      }
    })], 1)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1e7bd5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArchiveCollection.vue
// module id = 9+oy
// module chunks = 0